import { useState } from "react"
import { toast } from "sonner"
import { useDispatch } from "react-redux"
import "react-phone-number-input/style.css"
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input"
import { MyDispatch, MySelector } from "../../redux/store"
import { sendOtp, setPhoneNumber } from "../../redux/eventSlice"

const SendOtp = () => {
  const dispatch = useDispatch<MyDispatch>()
  const { loading } = MySelector((state) => state.event)

  const [number, setNumber] = useState<string>("")

  const sendCode = async () => {
    if (number === "") return toast.info("Please enter your Whatsapp number")
    dispatch(setPhoneNumber(number))
    dispatch(sendOtp(number))
  }

  return (
    <div>
      <p className="text-center font-[600] text-lg md:text-xl xl:text-2xl mb-[11px] lg:mb-[12px] text-brightBlack dark:text-offWhite">
        Login
      </p>
      <p className="text-offGrey dark:text-grey text-sm md:text-sm xl:text-base text-center font-[400] lg:px-4">
        We'll send you a code to verify your number.
      </p>

      <PhoneInput
        autoFocus
        placeholder="Enter your mobile no."
        value={number}
        defaultCountry="IN"
        onChange={(value: any) => setNumber(value)}
        international
        className="mb-4 mt-6 lg:mb-6 lg:mt-9 xl:mt-10 w-[253px] md:w-[295px] lg:w-full bg-transparent border-[0.5px] border-offGrey/80 focus:border-offWhite placeholder:text-offGrey text-brightBlack dark:text-offWhite font-hanken font-[400] outline-none rounded-2xl px-[16px] text-sm"
      />

      <button
        disabled={!number || !isValidPhoneNumber(number)}
        onClick={sendCode}
        className={`w-[253px] md:w-[295px] lg:w-full rounded-2xl py-[12px] lg:py-[15.5px] font-[500] leading-[19.36px] outline-none border flex justify-center items-center text-sm lg:text-sm xl:text-base ${
          number && isValidPhoneNumber(number)
            ? "bg-blackish dark:bg-golden text-white dark:text-blackish border-blackish dark:border-golden"
            : "bg-grey dark:bg-darkGrey text-white dark:text-offGrey border-grey dark:border-darkGrey"
        } ${
          number && isValidPhoneNumber(number)
            ? "cursor-pointer"
            : "cursor-not-allowed"
        }`}
      >
        {loading ? (
          <span className="h-5 w-5 rounded-full border-2 border-current border-t-transparent animate-spin" />
        ) : (
          "Confirm"
        )}
      </button>

    </div>
  )
}

export default SendOtp
